import { Component, Inject, OnInit } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { map } from 'rxjs/operators';

import { MatDialogRef, MAT_DIALOG_DATA, MatDialog } from '@angular/material/dialog';
import { User } from 'src/app/interfaces/user.interface';
import { ApiV2Service } from 'src/app/services/api-v2.service';
import { Activity } from '../../../models/activity.model';
import { Organization } from 'src/app/interfaces/organization-info.interface';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-dialog-copy-activity',
  templateUrl: './dialog-copy-activity.component.html',
  styleUrls: ['./dialog-copy-activity.component.css']
})
export class DialogCopyActivityComponent implements OnInit {

  copyActivityForm: FormGroup;
  activity: Activity;
  userTeachers: User[] = [];
  allUsers: User[] = [];
  organization: Organization;

  icons: any = {
    success: { icon: 'check_circle' },
    info: { icon: 'info' },
    danger: { icon: 'error' },
    warning: { icon: 'warning' },
    question: { icon: 'help' }
  }


  constructor(
    private api: ApiV2Service,
    private auth: AuthService,
    private dialogRef: MatDialogRef<DialogCopyActivityComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) {
    this.copyActivityForm = new FormGroup({
      email: new FormControl(null, Validators.required)
    });
  }



  ngOnInit(): void {
    this.organization = this.auth.currentMainOrganization;
    this.getUserByOrganization(); //llamar a funcion que carga y filtra usuarios de la organización
  }

  getUserByOrganization() {
    this.api.getAlternativeService('GET_USERS_BY_ORGANIZATIONS', this.organization.id).pipe(map((data) => {
      for (const key in data['results']) {
        if (data['results'].hasOwnProperty(key)) {
          data['results'][key]['isOrgAdmin'] = data['results'][key]['is_org_admin'];
          data['results'][key]['isSuperuser'] = data['results'][key]['is_superuser'];
          data['results'][key]['organizationRelationship'] = data['results'][key]['organization_relationship'];
          delete data['results'][key]['is_org_admin'];
          delete data['results'][key]['is_superuser'];
          delete data['results'][key]['organization_relationship'];
        }
      }
      return data['results']
    })).subscribe(
      (users: User[]) => {
        console.log(users);
        this.allUsers = users;
        this.userTeachers = users.filter((user: User) => user.organizationRelationship.includes('Profesor'));
        //this.parents = users.filter((user: User) => user.organizationRelationship.includes('Apoderado'));

        //this.spinner.showSpinner = false;
      },
      (error) => {
        console.log(error);
        //this.spinner.showSpinner = false;
      }
    );
  }

  TitleforSchool():boolean {
    if (this.auth.currentMainOrganization.organizationType === 'Escuela'){return true}
    else{return false;}
  }

  public closeMe() {
    this.dialogRef.close();
  }

}
